
import React, { useRef, useEffect } from "react";
import { Button } from "@/components/ui/button";
import BackgroundImage from "./BackgroundImage";

const WhyParticipate = () => {
  const cardStyle = {
    borderRadius: '20px',
    transition: 'all 0.8s cubic-bezier(0.19, 1, 0.22, 1)',
    willChange: 'transform, opacity'
  };

  return (
    <div className="relative" style={{ backgroundColor: 'var(--theme-bg)' }}>
      <section className="w-full py-16 md:py-24 overflow-hidden" id="why-participate" style={{
        backgroundColor: 'var(--theme-bg)',
        scrollMarginTop: '60px'
      }}>
        <div className="container px-6 lg:px-8 mx-auto">
          <div className="mb-8 md:mb-12">
            <div className="flex justify-center md:justify-start items-center gap-4 mb-8 md:mb-8 pt-4 sm:pt-2 md:pt-0">
              <div className="inline-flex items-center justify-center px-4 py-2 rounded-full opacity-0 animate-fade-in" style={{
                animationDelay: "0.1s",
                backgroundColor: 'rgba(242, 76, 39, 0.1)',
                border: '1px solid rgba(242, 76, 39, 0.2)',
                color: 'rgba(242, 76, 39, 1)'
              }}>
                <span className="inline-flex items-center justify-center w-5 h-5 rounded-full text-white mr-2" style={{
                  backgroundColor: 'rgba(242, 76, 39, 1)'
                }}>1</span>
                <span>Why Participate</span>
              </div>
            </div>
            
            <h2 className="section-title text-3xl sm:text-4xl md:text-5xl font-display font-bold mb-4 md:mb-10 pb-2 leading-[1.2] text-center md:text-left" style={{
              background: 'linear-gradient(135deg, rgba(242, 76, 39, 1) 0%, rgba(31, 31, 30, 1) 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent'
            }}>
              Why Join ai<span style={{
                color: 'rgba(242, 76, 39, 1)'
              }}>4</span>hack
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {/* First Card - Money & Funding */}
            <div 
              className="relative overflow-hidden shadow-xl opacity-0 animate-fade-in h-auto md:h-[35vh] md:max-h-[280px]" 
              style={{
                ...cardStyle,
                animationDelay: "0.3s",
                animationFillMode: "forwards"
              }}
            >
              <BackgroundImage 
                src="/lovable-uploads/451e8b9b-19c7-4715-8958-6b9c1a4c40fd.png"
                className="absolute inset-0 z-0"
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />
              
              <div className="absolute inset-0 bg-gradient-to-br from-[#F24C27]/25 via-[#F24C27]/15 to-[#1F1F1E]/20 z-5"></div>
              
              <div className="absolute top-4 right-4 z-20">
                <div className="inline-flex items-center justify-center px-4 py-2 rounded-full" style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(8px)',
                  color: 'white'
                }}>
                  <span className="text-sm font-medium">4 Winning Teams</span>
                </div>
              </div>
              
              <div className="relative z-10 px-5 sm:px-6 md:px-8 pt-5 sm:pt-6 md:pt-8 pb-3 sm:pb-4 md:pb-5 h-full flex items-end min-h-[220px] text-left">
                <div className="max-w-lg">
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-display text-white font-bold leading-tight mb-2">
                    Get <span style={{
                      color: 'rgba(242, 76, 39, 1)'
                    }}>$25,000</span> in early-stage funding for your breakthrough idea*
                  </h3>
                  <p className="text-xs text-white/70">
                    *if the project meets the criteria
                  </p>
                </div>
              </div>
            </div>
            
            {/* Second Card - Acceleration */}
            <div 
              className="relative overflow-hidden shadow-xl opacity-0 animate-fade-in h-auto md:h-[35vh] md:max-h-[280px]" 
              style={{
                ...cardStyle,
                animationDelay: "0.6s",
                animationFillMode: "forwards"
              }}
            >
              <BackgroundImage 
                src="/lovable-uploads/566a49a2-5553-4a8f-9fb1-2bd20c7ab011.png"
                className="absolute inset-0 z-0"
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />
              
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 via-purple-500/30 to-indigo-600/40 z-5"></div>
              
              <div className="absolute top-4 right-4 z-20">
                <div className="inline-flex items-center justify-center px-4 py-2 rounded-full" style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(8px)',
                  color: 'white'
                }}>
                  <span className="text-sm font-medium">Become a Startup</span>
                </div>
              </div>
              
              <div className="relative z-10 px-5 sm:px-6 md:px-8 pt-5 sm:pt-6 md:pt-8 pb-3 sm:pb-4 md:pb-5 h-full flex items-end min-h-[220px] text-left">
                <div className="max-w-lg">
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-display text-white font-bold leading-tight mb-4">
                    <span style={{
                      color: 'rgba(242, 76, 39, 1)'
                    }}>Acceleration program</span> for the winners showing potential to become a strong startup
                  </h3>
                </div>
              </div>
            </div>
            
            {/* Third Card - Silicon Valley Investors */}
            <div 
              className="relative overflow-hidden shadow-xl opacity-0 animate-fade-in h-auto md:h-[35vh] md:max-h-[280px]" 
              style={{
                ...cardStyle,
                animationDelay: "0.9s",
                animationFillMode: "forwards"
              }}
            >
              <BackgroundImage 
                src="/lovable-uploads/4c8d0304-78fa-4988-85a8-28e255469c97.png"
                className="absolute inset-0 z-0"
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />
              
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/20 via-teal-500/30 to-cyan-600/40 z-5"></div>
              
              <div className="absolute top-4 right-4 z-20">
                <div className="inline-flex items-center justify-center px-4 py-2 rounded-full" style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(8px)',
                  color: 'white'
                }}>
                  <span className="text-sm font-medium">Silicon Valley Access</span>
                </div>
              </div>
              
              <div className="relative z-10 px-5 sm:px-6 md:px-8 pt-5 sm:pt-6 md:pt-8 pb-3 sm:pb-4 md:pb-5 h-full flex items-end min-h-[220px] text-left">
                <div className="max-w-lg">
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-display text-white font-bold leading-tight mb-4">
                    <span style={{
                      color: 'rgba(242, 76, 39, 1)'
                    }}>Potential access</span> to Silicon Valley investors and VCs
                  </h3>
                </div>
              </div>
            </div>

            {/* Fourth Card - Partner Benefits with unique background */}
            <div 
              className="relative overflow-hidden shadow-xl opacity-0 animate-fade-in h-auto md:h-[35vh] md:max-h-[280px]" 
              style={{
                ...cardStyle,
                animationDelay: "1.2s",
                animationFillMode: "forwards"
              }}
            >
              <BackgroundImage 
                src="/lovable-uploads/451e8b9b-19c7-4715-8958-6b9c1a4c40fd.png"
                className="absolute inset-0 z-0"
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />
              
              <div className="absolute inset-0 bg-gradient-to-br from-amber-500/20 via-yellow-500/30 to-orange-600/40 z-5"></div>
              
              <div className="absolute top-4 right-4 z-20">
                <div className="inline-flex items-center justify-center px-4 py-2 rounded-full" style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(8px)',
                  color: 'white'
                }}>
                  <span className="text-sm font-medium">Partner Benefits</span>
                </div>
              </div>
              
              <div className="relative z-10 px-5 sm:px-6 md:px-8 pt-5 sm:pt-6 md:pt-8 pb-3 sm:pb-4 md:pb-5 h-full flex items-end min-h-[220px] text-left">
                <div className="max-w-lg">
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-display text-white font-bold leading-tight mb-4">
                    <span style={{
                      color: 'rgba(242, 76, 39, 1)'
                    }}>Contacts with mentors</span> from the industry
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyParticipate;
